var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarFindAvailability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22079_270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3C16.0128 3 16.4354 3.32188 16.4932 3.73633L16.5 3.83301V5H17.9502C19.3584 5.0001 20.5 6.07497 20.5 7.40039V18.5996C20.5 19.925 19.3584 20.9999 17.9502 21H6.0498C4.64157 20.9999 3.5 19.925 3.5 18.5996V7.40039C3.5 6.07497 4.64157 5.0001 6.0498 5H7.5V3.83301C7.50021 3.37292 7.94785 3 8.5 3C9.01284 3 9.4354 3.32188 9.49316 3.73633L9.5 3.83301V5H14.5V3.83301C14.5002 3.37292 14.9478 3 15.5 3ZM5.2002 18.5996C5.2002 19.0414 5.58045 19.4003 6.0498 19.4004H17.9502C18.4195 19.4003 18.7998 19.0414 18.7998 18.5996V11H5.2002V18.5996ZM6.0498 6.59961C5.58045 6.59971 5.2002 6.95862 5.2002 7.40039V9H18.7998V7.40039C18.7998 6.95862 18.4195 6.59971 17.9502 6.59961H16.5V7.16699C16.4998 7.62708 16.0522 8 15.5 8C14.9872 8 14.5646 7.67812 14.5068 7.26367L14.5 7.16699V6.59961H9.5V7.16699C9.49979 7.62708 9.05215 8 8.5 8C7.98716 8 7.5646 7.67812 7.50684 7.26367L7.5 7.16699V6.59961H6.0498Z",
    fill: "#668A90"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22079_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3V11H12V21H21V3Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1374 17.8674H0.873077C0.625705 17.8674 0.418349 17.7837 0.25101 17.6164C0.0836698 17.4491 0 17.2417 0 16.9943C0 16.747 0.0836698 16.5396 0.25101 16.3723C0.418349 16.2049 0.625705 16.1212 0.873077 16.1212H7.1374L5.50038 14.4624C5.34032 14.3023 5.25665 14.1023 5.24937 13.8622C5.2421 13.6221 5.32577 13.4147 5.50038 13.2401C5.66045 13.08 5.86416 13 6.11154 13C6.35891 13 6.56263 13.08 6.72269 13.2401L9.86577 16.3832C10.0404 16.5578 10.1277 16.7615 10.1277 16.9943C10.1277 17.2271 10.0404 17.4309 9.86577 17.6055L6.72269 20.7486C6.56263 20.9086 6.36255 20.9923 6.12245 20.9996C5.88235 21.0068 5.675 20.9232 5.50038 20.7486C5.34032 20.5885 5.26029 20.3848 5.26029 20.1374C5.26029 19.89 5.34032 19.6863 5.50038 19.5262L7.1374 17.8674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarFindAvailability);
export default __webpack_public_path__ + "static/media/Calendar-Find-Availability.46286ecdbe6ef7a092308d56d1ac5c21.svg";
export { ForwardRef as ReactComponent };